import type { FC } from "react";

import { Button, type ButtonProps, classes } from "@alpacahq/ui/old";

export const ProgressionButton: FC<ButtonProps> = (props) => (
  <Button
    className={classes("w-full max-w-[112px]", props.className)}
    {...props}
  >
    {props.children}
  </Button>
);
